import { useContext, useEffect } from "react";
import { api } from "../App";

import Card from "./card";
import Loading from "./loading";

const Page = () => {
  const { apiData } = useContext(api);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return !!apiData.length ? (
    <div className="api-data">
      {apiData.map((obj) => (
        <Card obj={obj} key={obj.id} />
      ))}
    </div>
  ) : (
    <Loading />
  );
};

export default Page;
